import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { FaChalkboard } from 'react-icons/fa';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input/Input';
import AssignmentGrid from '../../components/AssignmentGrid/AssignmentGrid';

const SubjectForm = ({ onSubmit, onChange, onInputChange, onSwitchChange,
  name, programData, programIds, loader }) => {
  return (
    <Form onSubmit={onSubmit}>
      {loader && <div className="loader"><Loader /></div>}
      <div className="row">
        <div className="col-md-12 mb-3">
          <Input
            label="Name"
            type="text"
            name="name"
            value={name}
            onChangeHandler={onChange}
            placeholder="Enter subject name"
            required={true}
          />
        </div>

        <AssignmentGrid
          label="Available for classes"
          icon={<FaChalkboard />}
          items={programData}
          selectedIds={programIds}
          onToggle={onInputChange}
          onSelectAll={onSwitchChange}
          switchName="programIds"
        />

        <div className="col-md-12 justify-content-end d-flex mt-3">
          <div>
            <Button
              variant="success"
              disabled={loader}
              type="submit">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default SubjectForm;
